module.exports = __webpack_public_path__ + "static/media/barcode.ac3585f6.svg";